import React, { useState, useEffect, useRef } from "react";
import MasterplanSVG from "./MasterplanSVG";

// ─── HOOK FADE-IN AL SCROLL ───────────────────────────────────────────────────
function useFadeIn(threshold = 0.15) {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); obs.disconnect(); } },
      { threshold }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, [threshold]);
  return [ref, visible];
}

// ─── DATOS ────────────────────────────────────────────────────────────────────
const MANZANAS = [
  { id:"99", nombre:"Manzana Frente al Mar", descripcion:"Primera línea con vista directa al mar. Orientación este.", lotes:[
    {numero:5,superficie:307.84,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:6,superficie:306.55,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:7,superficie:309.48,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:8,superficie:315.69,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:9,superficie:332.58,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:10,superficie:346.33,precio:49000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:11,superficie:360.09,precio:49000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:12,superficie:373.85,precio:49000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:15,superficie:613.26,precio:55000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:16,superficie:366.16,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:17,superficie:312.43,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:18,superficie:311.67,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:19,superficie:303.00,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:20,superficie:314.87,precio:50000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:21,superficie:393.76,precio:50000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:22,superficie:363.16,precio:50000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:23,superficie:547.49,precio:50000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:24,superficie:343.68,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:25,superficie:358.09,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:26,superficie:402.37,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:27,superficie:473.11,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:1,superficie:480.85,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:2,superficie:477.19,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:3,superficie:473.55,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:4,superficie:470.40,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:13,superficie:387.60,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
    {numero:14,superficie:529.38,precio:null,descripcion:"Vista al Mar",estado:"vendido"},
  ]},
  { id:"101", nombre:"Manzana Premium", descripcion:"Acceso directo a la playa, servicios completos.", lotes:[
    {numero:19,superficie:312.50,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:21,superficie:312.50,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:22,superficie:312.50,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:23,superficie:312.50,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:24,superficie:318.52,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:25,superficie:396.39,precio:27000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:27,superficie:300.00,precio:20500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:29,superficie:300.00,precio:20500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:30,superficie:318.70,precio:20500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:45,superficie:300.10,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:47,superficie:362.91,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:48,superficie:356.00,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
  ]},
  { id:"105", nombre:"Manzana Río y Mar", descripcion:"Entre el río Chubut y el mar, vistas únicas.", lotes:[
    {numero:20,superficie:301.25,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:21,superficie:301.25,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:22,superficie:301.25,precio:24000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:23,superficie:562.50,precio:26500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:25,superficie:373.35,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:26,superficie:356.29,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:27,superficie:360.28,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:28,superficie:360.28,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:29,superficie:360.28,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:31,superficie:479.77,precio:23000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:33,superficie:360.00,precio:22000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:41,superficie:720.00,precio:36000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:42,superficie:540.00,precio:34600,descripcion:"Vista al Mar",estado:"disponible"},
  ]},
  { id:"109", nombre:"Manzana Barrancas", descripcion:"Las mejores vistas panorámicas del desarrollo.", lotes:[
    {numero:2,superficie:600.00,precio:52000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:3,superficie:600.00,precio:52000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:5,superficie:600.00,precio:52000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:6,superficie:600.00,precio:52000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:10,superficie:457.04,precio:45000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:11,superficie:424.19,precio:45000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:12,superficie:529.58,precio:48000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:13,superficie:406.88,precio:45500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:14,superficie:399.87,precio:45500,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:15,superficie:328.66,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:16,superficie:305.22,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:17,superficie:305.22,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:18,superficie:305.22,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:19,superficie:301.67,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:20,superficie:300.64,precio:40000,descripcion:"Vista al Mar",estado:"disponible"},
    {numero:21,superficie:303.96,precio:24000,descripcion:"Alejado del Mar",estado:"disponible"},
    {numero:22,superficie:334.38,precio:null,descripcion:"Alejado del Mar",estado:"vendido"},
    {numero:23,superficie:301.67,precio:null,descripcion:"Alejado del Mar",estado:"vendido"},
    {numero:26,superficie:305.22,precio:null,descripcion:"Alejado del Mar",estado:"vendido"},
    {numero:27,superficie:305.22,precio:null,descripcion:"Alejado del Mar",estado:"vendido"},
    {numero:28,superficie:396.34,precio:26000,descripcion:"Alejado del Mar",estado:"disponible"},
    {numero:29,superficie:396.34,precio:26000,descripcion:"Alejado del Mar",estado:"disponible"},
    {numero:30,superficie:623.43,precio:34000,descripcion:"Alejado del Mar",estado:"disponible"},
    {numero:31,superficie:705.09,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:32,superficie:471.72,precio:34000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:33,superficie:471.72,precio:34000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:34,superficie:471.72,precio:34000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:35,superficie:471.72,precio:34000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:36,superficie:439.26,precio:33000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:37,superficie:331.53,precio:31000,descripcion:"Primera Fila",estado:"disponible"},
    {numero:38,superficie:325.84,precio:36000,descripcion:"Primera Fila",estado:"disponible"},
  ]},
];

const LOTES_DESTACADOS = [
  {manzana:"99", numero:15, superficie:613.26, precio:55000, descripcion:"Vista al Mar", badge:"Más grande"},
  {manzana:"99", numero:23, superficie:547.49, precio:50000, descripcion:"Primera Fila", badge:"Primera Fila"},
  {manzana:"109",numero:2,  superficie:600.00, precio:52000, descripcion:"Vista al Mar", badge:"Barrancas"},
  {manzana:"109",numero:31, superficie:705.09, precio:36000, descripcion:"Primera Fila", badge:"Mejor precio/m²"},
  {manzana:"105",numero:41, superficie:720.00, precio:36000, descripcion:"Vista al Mar", badge:"El más grande"},
];

const WHATSAPP = "5492804957718";
const EMAIL = "garzoniocarlos@gmail.com";

// ─── NAVBAR ───────────────────────────────────────────────────────────────────
function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 60);
    window.addEventListener("scroll", fn, { passive:true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  const navLinks = [
    ["#proyecto","El Proyecto"],
    ["#empresa","Nosotros"],
    ["#lotes","Lotes"],
    ["#ubicacion","Ubicación"],
  ];
  const solid = scrolled || menuOpen;
  const closeMenu = () => setMenuOpen(false);
  return (
    <nav className="fixed top-0 w-full z-50 transition-all duration-500"
      style={{
        backgroundColor: solid ? "rgba(255,255,255,0.98)" : "transparent",
        boxShadow: scrolled ? "0 1px 30px rgba(0,85,165,0.1)" : "none",
        backdropFilter: solid ? "blur(16px)" : "none",
        borderBottom: solid ? "1px solid rgba(0,85,165,0.08)" : "none",
      }}>
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center">
        {/* Hamburger LEFT (mobile only) */}
        <button className="md:hidden flex flex-col justify-center items-center w-10 h-10 gap-[5px] flex-shrink-0"
          onClick={() => setMenuOpen(o => !o)} aria-label="Menú">
          <span className="block h-0.5 rounded-full transition-all duration-300"
            style={{ width:20, backgroundColor: solid ? "#0055a5" : "white", transform: menuOpen ? "rotate(45deg) translate(4px,4px)" : "none" }}/>
          <span className="block h-0.5 rounded-full transition-all duration-300"
            style={{ width:20, backgroundColor: solid ? "#0055a5" : "white", opacity: menuOpen ? 0 : 1 }}/>
          <span className="block h-0.5 rounded-full transition-all duration-300"
            style={{ width:menuOpen ? 20 : 14, backgroundColor: solid ? "#0055a5" : "white", transform: menuOpen ? "rotate(-45deg) translate(4px,-4px)" : "none", alignSelf:"flex-start" }}/>
        </button>
        {/* Logos — desktop: left, mobile: pushed to right with ml-auto */}
        <div className="flex items-center gap-4 ml-auto md:ml-0">
          <img
            src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto/v1773871049/ChatGPT_Image_16_dic_2025_03_55_53_z1g4sb.png"
            alt="Garzonio Propiedades"
            className="h-12 md:h-16 w-auto object-contain transition-all duration-500"
            style={{ filter: solid ? "none" : "brightness(0) invert(1)" }}
            onError={e => e.target.style.display="none"}
          />
          <div style={{ width:1, height:36, background: solid ? "rgba(0,85,165,0.25)" : "rgba(255,255,255,0.3)", transition:"background 0.5s" }}/>
          <img
            src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto,h_120/v1774387303/BarrancasBlancas_iczxxd.png"
            alt="Barrancas Blancas"
            className="h-10 md:h-14 w-auto object-contain transition-all duration-500"
            style={{ filter: solid ? "none" : "brightness(0) invert(1)" }}
            onError={e => e.target.style.display="none"}
          />
        </div>

        {/* Desktop nav */}
        <div className="hidden md:flex ml-auto gap-8 items-center text-[11px] font-black uppercase tracking-[0.2em] transition-colors duration-500"
          style={{ color: scrolled ? "#0055a5" : "rgba(255,255,255,0.9)" }}>
          {navLinks.map(([h,l]) => (
            <a key={h} href={h} className="hover:opacity-60 transition-opacity">{l}</a>
          ))}
          <a href="#contacto"
            className="px-5 py-2.5 rounded-full transition-all duration-300 font-black"
            style={{
              border: `2px solid ${scrolled ? "#0055a5" : "rgba(255,255,255,0.7)"}`,
              color: scrolled ? "#0055a5" : "white",
              backgroundColor: "transparent",
            }}
            onMouseEnter={e => { e.currentTarget.style.backgroundColor="#0055a5"; e.currentTarget.style.color="white"; e.currentTarget.style.borderColor="#0055a5"; }}
            onMouseLeave={e => { e.currentTarget.style.backgroundColor="transparent"; e.currentTarget.style.color=scrolled?"#0055a5":"white"; e.currentTarget.style.borderColor=scrolled?"#0055a5":"rgba(255,255,255,0.7)"; }}>
            Consultar
          </a>
        </div>

      </div>

      {/* Mobile menu */}
      <div className="md:hidden overflow-hidden transition-all duration-300"
        style={{ maxHeight: menuOpen ? 400 : 0 }}>
        <div className="px-6 pb-6 pt-2 border-t border-blue-100 flex flex-col gap-1">
          {navLinks.map(([h,l]) => (
            <a key={h} href={h} onClick={closeMenu}
              className="py-3 px-4 rounded-2xl text-[#0055a5] font-black text-sm uppercase tracking-widest hover:bg-blue-50 transition-colors">
              {l}
            </a>
          ))}
          <a href="#contacto" onClick={closeMenu}
            className="mt-2 py-4 rounded-2xl bg-[#0055a5] text-white font-black text-sm uppercase tracking-widest text-center hover:bg-blue-700 transition-colors">
            Consultar ahora
          </a>
        </div>
      </div>
    </nav>
  );
}

// ─── HERO ─────────────────────────────────────────────────────────────────────
function Hero() {
  const [loaded, setLoaded] = useState(false);
  useEffect(() => { const t = setTimeout(() => setLoaded(true), 80); return () => clearTimeout(t); }, []);

  return (
    <section className="relative h-screen w-full flex items-end justify-center overflow-hidden">
      <video autoPlay loop muted playsInline
        preload="auto"
        poster="https://res.cloudinary.com/dtvtmh8hq/video/upload/so_0,w_1920,q_auto,f_auto/VideoBarrancasBlancas_ckldm3.jpg"
        className="absolute inset-0 z-0 w-full h-full object-cover">
        <source src="https://res.cloudinary.com/dtvtmh8hq/video/upload/q_auto:eco,br_1500k,w_1280/v1775513991/VideoBarrancasBlancas_ckldm3.mp4" type="video/mp4"/>
      </video>

      {/* Gradient — fuerte abajo para texto, suave arriba */}
      <div className="absolute inset-0 z-10"
        style={{ background: "linear-gradient(to top, rgba(0,0,0,0.85) 0%, rgba(0,20,60,0.5) 40%, rgba(0,30,80,0.2) 100%)" }}/>

      {/* Contenido — anclado al fondo */}
      <div className="relative z-20 w-full max-w-7xl mx-auto px-6 pb-20 md:pb-28">
        <div style={{ opacity: loaded ? 1 : 0, transform: loaded ? "none" : "translateY(24px)", transition: "opacity 1s ease, transform 1s ease" }}>


          {/* Título */}
          <h1 className="text-white font-black leading-none mb-6"
            style={{ fontSize: "clamp(3.5rem, 10vw, 9rem)", letterSpacing: "-0.03em",
              textShadow: "0 2px 40px rgba(0,0,0,0.4)",
              opacity: loaded ? 1 : 0, transition: "opacity 1s ease 0.1s" }}>
            BARRANCAS<br/>
            <span className="hero-blancas">BLANCAS</span>
          </h1>

          {/* Bajada */}
          <p className="text-white/80 text-lg md:text-xl max-w-xl mb-10 font-light leading-relaxed"
            style={{ opacity: loaded ? 1 : 0, transition: "opacity 1s ease 0.3s" }}>
            Lotes frente al Océano Atlántico en la Patagonia argentina. Invertí donde el mar y las barrancas se encuentran.
          </p>

          {/* CTAs */}
          <div className="flex flex-wrap gap-4"
            style={{ opacity: loaded ? 1 : 0, transition: "opacity 1s ease 0.45s" }}>
            <a href="#lotes"
              className="inline-flex items-center gap-2 bg-white text-[#0055a5] px-8 py-4 rounded-full font-black text-sm uppercase tracking-wider shadow-2xl hover:scale-105 active:scale-95 transition-transform">
              Ver lotes disponibles
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
            <a href="#proyecto"
              className="inline-flex items-center gap-2 border-2 border-white/50 text-white px-8 py-4 rounded-full font-semibold text-sm uppercase tracking-wider hover:bg-white/10 transition-colors">
              Conocer el proyecto
            </a>
          </div>
        </div>
      </div>

      {/* Scroll hint */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 flex flex-col items-center gap-2"
        style={{ opacity: loaded ? 0.5 : 0, transition: "opacity 1.5s ease 1s", animation: "bounce 2s ease-in-out infinite" }}>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 3v14M5 13l5 5 5-5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
      </div>
      <style>{`@keyframes bounce{0%,100%{transform:translateX(-50%) translateY(0)}50%{transform:translateX(-50%) translateY(6px)}}`}</style>
    </section>
  );
}

// ─── STATS BAR ────────────────────────────────────────────────────────────────
function StatsBar() {
  const [ref, visible] = useFadeIn(0.1);
  const TOTAL_DISPONIBLES = MANZANAS.reduce((acc, m) => acc + m.lotes.filter(l => l.estado === "disponible").length, 0);
  const TOTAL_VENDIDOS    = MANZANAS.reduce((acc, m) => acc + m.lotes.filter(l => l.estado === "vendido").length, 0);
  const stats = [
    { value: TOTAL_DISPONIBLES, label: "Lotes disponibles" },
    { value: TOTAL_VENDIDOS,    label: "Ya vendidos" },
    { value: "4",               label: "Manzanas" },
    { value: "285+",            label: "m² desde" },
  ];
  return (
    <div ref={ref} style={{ background: "linear-gradient(135deg, #003d7a 0%, #0055a5 100%)", opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(30px)", transition: "opacity 0.7s ease, transform 0.7s ease" }} className="py-8 px-6">
      <div className="max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 divide-x divide-white/10">
        {stats.map((s, i) => (
          <div key={s.label} className={`text-center text-white ${i > 0 ? "pl-6" : ""}`}>
            <p className="text-4xl md:text-5xl font-black mb-1 tabular-nums">{s.value}</p>
            <p className="text-[10px] uppercase tracking-[0.25em] opacity-50 font-semibold">{s.label}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

// ─── EL PROYECTO ──────────────────────────────────────────────────────────────
function Proyecto() {
  const [ref, visible] = useFadeIn();
  const amenities = [
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z"/></svg>, label: "Luz eléctrica" },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 2.25C8.25 6 6 9.75 6 13.5a6 6 0 0012 0c0-3.75-2.25-7.5-6-11.25z"/></svg>, label: "Agua potable" },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3 7.5h18M3 12h18M3 16.5h18M8 3l-3 18M16 3l3 18"/></svg>, label: "Calles enripiadas" },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M2 19h20M2 19v-5h9v-3h11M2 14h9"/></svg>, label: "Cordón cuneta" },
  ];
  return (
    <section ref={ref} id="proyecto" className="py-24 px-6 bg-[#F9F7F2]"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-16 lg:gap-24 items-center">

        {/* Imagen */}
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl aspect-[4/3]">
            <img
              src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto,w_1200/v1774387394/Proyecto_funz1k.png"
              className="w-full h-full object-cover" alt="Barrancas Blancas" loading="lazy"/>
            {/* Badge flotante */}
            <div className="absolute top-6 left-6 bg-white rounded-2xl shadow-xl px-4 py-3">
              <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold">Rawson, Chubut</p>
              <p className="text-lg font-black text-[#0055a5]">Patagonia Argentina</p>
            </div>
            <div className="absolute bottom-6 right-6 bg-[#0055a5] rounded-2xl px-4 py-3 text-white text-right">
              <p className="text-[10px] uppercase tracking-widest opacity-60 font-bold">A solo</p>
              <p className="text-xl font-black">50m del mar</p>
            </div>
          </div>
          {/* Decoración */}
          <div className="absolute -z-10 -bottom-8 -right-8 w-2/3 h-2/3 rounded-3xl bg-[#0055a5]/8 border border-[#0055a5]/15"/>
        </div>

        {/* Texto */}
        <div>
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-5 block">El Proyecto</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight mb-6">
            Casi 50 años<br/>
            <span className="text-[#0055a5]">eligiendo el mejor terreno.</span>
          </h2>
          <p className="text-slate-600 text-lg leading-relaxed mb-10">
            En Garzonio Propiedades seleccionamos las mejores parcelas de <strong className="text-slate-800">Barrancas Blancas</strong> para ofrecerte una inversión segura frente al Atlántico patagónico. Lotes desde 285m² con infraestructura completa y vistas panorámicas.
          </p>

          {/* Amenities */}
          <div className="grid grid-cols-2 gap-3 mb-10">
            {amenities.map(a => (
              <div key={a.label} className="flex items-center gap-3 bg-white rounded-2xl px-4 py-3 shadow-sm border border-stone-100">
                <div className="flex-shrink-0">{a.icon}</div>
                <span className="text-sm font-semibold text-slate-700">{a.label}</span>
              </div>
            ))}
          </div>

          {/* Métricas */}
          <div className="flex gap-8">
            {[["180°","Vista al Mar"],["50m","A la Playa"],["4","Manzanas"]].map(([v,l]) => (
              <div key={l}>
                <p className="text-3xl font-black text-[#0055a5]">{v}</p>
                <p className="text-xs uppercase tracking-widest text-slate-400 font-bold mt-1">{l}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── GALERÍA ──────────────────────────────────────────────────────────────────
function Galeria() {
  const [ref, visible] = useFadeIn();
  const puntos = [
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3 8.25c.84-.68 1.8-1.02 2.75-1.02 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97M3 14.25c.84-.68 1.8-1.02 2.75-1.02 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97"/></svg>, titulo:"Frente al Atlántico", texto:"Lotes con vista directa al Océano Atlántico. Despertarte con el mar en frente no tiene precio — pero acá tiene uno." },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M3.5 20l5.5-9 4 5 3.5-5 5 9H3.5z"/></svg>, titulo:"Las barrancas como límite", texto:"El borde de las barrancas define el horizonte de cada lote. Una geografía única en todo el litoral patagónico." },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v2.25m6.364.386l-1.591 1.591M21 12h-2.25m-.386 6.364l-1.591-1.591M12 18.75V21m-4.773-4.227l-1.591 1.591M5.25 12H3m4.227-4.773L5.636 5.636M15.75 12a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"/></svg>, titulo:"Atardeceres únicos", texto:"El sol cae directo sobre el mar. Cada tarde es un espectáculo que se repite solo para los que eligieron vivir acá." },
    { icon: <svg className="w-5 h-5 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}><path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z"/><path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z"/></svg>, titulo:"A 5 minutos de Playa Unión", texto:"Todo el encanto de la Patagonia costera, con acceso rápido a servicios, gastronomía y la playa más popular de Rawson." },
  ];
  return (
    <section className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">El lugar</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900">Un lugar que habla solo.</h2>
        </div>

        <div className="grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Imagen única */}
          <div className="relative overflow-hidden rounded-3xl shadow-2xl" style={{minHeight:520}}>
            <img
              src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto,w_1600/v1783903279/WhatsApp_Image_2026-07-10_at_4.26.58_PM_eg4ap7.jpg"
              className="w-full h-full object-cover absolute inset-0"
              style={{minHeight:520}}
              alt="Barrancas Blancas — Vista desde las barrancas"
              loading="lazy"/>
            {/* Gradient sutil abajo */}
            <div className="absolute inset-0" style={{background:"linear-gradient(to top, rgba(0,0,0,0.55) 0%, transparent 50%)"}}/>
            {/* Badge */}
            <div className="absolute bottom-8 left-8">
              <span className="inline-block bg-white/15 backdrop-blur-md text-white text-[10px] font-black px-4 py-2 rounded-full uppercase tracking-[0.25em] border border-white/25">
                Barrancas Blancas · Rawson, Chubut
              </span>
            </div>
          </div>

          {/* Descripción de ventas */}
          <div>
            <p className="text-slate-500 text-lg leading-relaxed mb-10">
              Hay pocos lugares en Argentina donde podés pararte al borde de una barranca y ver el mar Atlántico extenderse hasta el horizonte. <strong className="text-slate-800">Barrancas Blancas es uno de ellos.</strong>
            </p>

            <div className="space-y-6">
              {puntos.map((p, i) => (
                <div key={i} className="flex gap-4 items-start">
                  <div className="flex-shrink-0 w-10 h-10 rounded-2xl bg-[#0055a5]/8 flex items-center justify-center">
                    {p.icon}
                  </div>
                  <div>
                    <p className="font-black text-slate-800 mb-1">{p.titulo}</p>
                    <p className="text-slate-500 text-sm leading-relaxed">{p.texto}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-stone-100 flex flex-wrap gap-8">
              {[["180°","Vista panorámica"],["50m","Del mar"],["4","Manzanas"]].map(([v,l])=>(
                <div key={l}>
                  <p className="text-3xl font-black text-[#0055a5]">{v}</p>
                  <p className="text-xs uppercase tracking-widest text-slate-400 font-bold mt-1">{l}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── EMPRESA ──────────────────────────────────────────────────────────────────
function Empresa() {
  const [ref, visible] = useFadeIn();
  const puntos = [
    "Casi 50 años de trayectoria inmobiliaria en la Patagonia",
    "Más de 1.000 lotes escriturados en la región",
    "Empresa familiar con presencia en Chubut",
    "Servicio personalizado de principio a fin",
    "Financiación propia en pesos y dólares",
    "Respaldo legal y notarial en cada operación",
  ];
  return (
    <section ref={ref} id="empresa" className="py-24 px-6 bg-[#F9F7F2]"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Quiénes somos</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 leading-tight">
            Experiencia y confianza<br/><span className="text-[#0055a5]">en cada proyecto.</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-5 gap-8 items-start">
          {/* Card empresa */}
          <div className="md:col-span-2 bg-white rounded-3xl shadow-sm overflow-hidden border border-stone-100">
            <div className="px-8 py-10 text-center" style={{background:"linear-gradient(145deg,#003d7a,#0055a5)"}}>
              <img
                src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto/v1773871049/ChatGPT_Image_16_dic_2025_03_55_53_z1g4sb.png"
                alt="Garzonio" className="h-12 w-auto mx-auto mb-5 object-contain"
                style={{filter:"brightness(0) invert(1)"}} onError={e=>e.target.style.display="none"}/>
              <span className="inline-block border border-white/25 text-white/80 text-[10px] font-black uppercase px-4 py-1.5 rounded-full tracking-[0.2em] mb-4">Comercializadora</span>
              <h3 className="text-white text-xl font-black">Garzonio Propiedades</h3>
              <p className="text-white/50 text-sm mt-1">Trelew, Chubut · Desde 1977</p>
            </div>
            <div className="px-8 py-6 grid grid-cols-3 divide-x divide-stone-100 border-b border-stone-100">
              {[["~50","años"],["1000+","lotes"],["3ª","generación"]].map(([v,l])=>(
                <div key={l} className="text-center px-2">
                  <p className="text-2xl font-black text-[#0055a5]">{v}</p>
                  <p className="text-[10px] uppercase tracking-wide text-slate-400 mt-1 font-bold">{l}</p>
                </div>
              ))}
            </div>
            <div className="px-8 py-6">
              <a href="#contacto" onClick={e=>{e.preventDefault();document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"})}}
                className="block w-full text-center bg-[#0055a5] text-white py-3.5 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-blue-700 active:scale-95 transition-all">
                Hablar con un asesor
              </a>
            </div>
          </div>

          {/* Lista de puntos */}
          <div className="md:col-span-3">
            <p className="text-slate-600 text-lg leading-relaxed mb-8">
              Somos una empresa familiar con casi 50 años en el mercado inmobiliario patagónico. Nos apasiona ayudar a las personas a encontrar su lugar ideal para vivir e invertir, con un servicio honesto y cercano en cada etapa del proceso.
            </p>
            <ul className="space-y-4">
              {puntos.map((p, i) => (
                <li key={i} className="flex items-center gap-4">
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-[#0055a5]/10 flex items-center justify-center">
                    <svg className="w-4 h-4 text-[#0055a5]" fill="none" viewBox="0 0 16 16">
                      <path d="M3 8l4 4 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span className="text-slate-700 font-medium">{p}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── LOTES DESTACADOS ─────────────────────────────────────────────────────────
const BADGE_COLORS = {
  "Primera Fila":   { bg:"#0055a5", text:"white" },
  "Más grande":     { bg:"#059669", text:"white" },
  "Barrancas":      { bg:"#7c3aed", text:"white" },
  "Mejor precio/m²":{ bg:"#d97706", text:"white" },
  "El más grande":  { bg:"#059669", text:"white" },
  "Oportunidad":    { bg:"#dc2626", text:"white" },
};

function LotesDestacados() {
  const [ref, visible] = useFadeIn();
  const goContact = () => document.getElementById("contacto")?.scrollIntoView({ behavior:"smooth" });
  const totalDisp = MANZANAS.reduce((acc, m) => acc + m.lotes.filter(l => l.estado === "disponible").length, 0);
  return (
    <section ref={ref} className="py-24 px-6 bg-white"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-6xl mx-auto">
        <div className="flex items-end justify-between mb-12 flex-wrap gap-4">
          <div>
            <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Selección especial</span>
            <h2 className="text-4xl md:text-5xl font-black text-slate-900">Lotes destacados</h2>
          </div>
          <div className="flex items-center gap-3 flex-wrap">
            <span className="inline-flex items-center gap-1.5 bg-red-50 border border-red-200 text-red-600 text-xs font-black px-4 py-2 rounded-full">
              <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse inline-block"/>
              Solo {totalDisp} lotes disponibles
            </span>
            <a href="#lotes" className="hidden md:inline-flex items-center gap-2 text-[#0055a5] font-bold text-sm uppercase tracking-wider hover:opacity-70 transition-opacity">
              Ver todos
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
            </a>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {LOTES_DESTACADOS.map((l, i) => {
            const badgeStyle = BADGE_COLORS[l.badge] || { bg:"#0055a5", text:"white" };
            return (
              <div key={i} className="group bg-white border border-stone-100 rounded-3xl overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300">
                {/* Header visual */}
                <div className="relative h-40 overflow-hidden"
                  style={{background:`linear-gradient(135deg, #002855 0%, #0055a5 60%, #1a7ad4 100%)`}}>
                  <div className="absolute inset-0 opacity-[0.07]"
                    style={{backgroundImage:"url(https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=20&w=400)",backgroundSize:"cover",backgroundPosition:"center"}}/>
                  {/* Patrón decorativo */}
                  <div className="absolute inset-0" style={{backgroundImage:"radial-gradient(circle at 80% 20%, rgba(255,255,255,0.08) 0%, transparent 60%)"}}/>
                  <div className="absolute inset-0 p-6 flex flex-col justify-between">
                    <span className="inline-block self-start text-[10px] font-black uppercase px-3 py-1.5 rounded-full tracking-wider"
                      style={{backgroundColor:badgeStyle.bg,color:badgeStyle.text}}>
                      {l.badge}
                    </span>
                    <div>
                      <p className="text-white/50 text-[10px] font-bold uppercase tracking-widest">Mzna {l.manzana} · Parcela {l.numero}</p>
                      <p className="text-white font-black text-lg mt-0.5">{l.descripcion}</p>
                    </div>
                  </div>
                </div>

                {/* Info */}
                <div className="p-5">
                  <div className="flex justify-between items-center mb-5">
                    <div>
                      <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1">Superficie</p>
                      <p className="text-2xl font-black text-slate-800">{l.superficie} <span className="text-sm font-normal text-slate-400">m²</span></p>
                    </div>
                    <div className="text-right">
                      <p className="text-[10px] uppercase tracking-widest text-slate-400 font-bold mb-1">Precio</p>
                      <p className="text-2xl font-black text-[#0055a5]">USD {l.precio.toLocaleString()}</p>
                      <p className="text-[10px] text-slate-400 font-medium mt-0.5">USD {Math.round(l.precio/l.superficie).toLocaleString()}/m²</p>
                    </div>
                  </div>
                  <button onClick={goContact}
                    className="w-full py-3 rounded-2xl font-black uppercase tracking-wider text-xs transition-all border-2 border-[#0055a5] text-[#0055a5] hover:bg-[#0055a5] hover:text-white active:scale-95">
                    Consultar disponibilidad
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}

// ─── SECCIÓN LOTES ────────────────────────────────────────────────────────────
function SeccionLotes() {
  const [ref, visible] = useFadeIn(0.05);
  return (
    <section ref={ref} id="lotes" className="py-24 px-6 bg-[#F9F7F2]"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Disponibilidad</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-3">Masterplan</h2>
          <p className="text-slate-500 max-w-md mx-auto">Seleccioná una manzana para explorar los lotes disponibles.</p>
        </div>
        <div className="bg-white rounded-3xl shadow-sm border border-stone-100 p-6 md:p-8">
          <MasterplanSVG />
        </div>
      </div>
    </section>
  );
}

// ─── FINANCIAMIENTO ───────────────────────────────────────────────────────────
function Financiamiento() {
  const [monto, setMonto]   = useState(40000);
  const [anticipo, setAnticipo] = useState(20);
  const [plazo, setPlazo]   = useState(60);
  const [tipo, setTipo]     = useState("usd");

  const [ref, visible] = useFadeIn(0.05);
  const TC = 1400;
  const tasa = tipo === "usd" ? 0.005 : 0.03;
  const montoBase = tipo === "usd" ? monto : monto * TC;
  const prestamo  = montoBase * (1 - anticipo / 100);
  const cuota     = prestamo * (tasa * Math.pow(1+tasa, plazo)) / (Math.pow(1+tasa, plazo) - 1);
  const anticipoImporte = montoBase * anticipo / 100;

  const fmt = (n) => n.toLocaleString("es-AR", { maximumFractionDigits: 0 });

  return (
    <section ref={ref} id="financiamiento" className="py-24 px-6 bg-white"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Invertí a tu ritmo</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-3">Simulador de cuotas</h2>
          <p className="text-slate-500 max-w-md mx-auto">Calculá tu cuota mensual y empezá a planificar.</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {/* Panel sliders */}
          <div className="bg-[#F9F7F2] rounded-3xl p-8 space-y-8">
            {/* Toggle moneda */}
            <div className="flex rounded-2xl overflow-hidden border border-stone-200 bg-white p-1 gap-1">
              {[["usd","USD — Dólares"],["ars","ARS — Pesos"]].map(([v,l]) => (
                <button key={v} onClick={() => setTipo(v)}
                  className="flex-1 py-2.5 rounded-xl text-xs font-black uppercase tracking-wider transition-all"
                  style={{ backgroundColor: tipo===v?"#0055a5":"transparent", color: tipo===v?"white":"#94a3b8" }}>
                  {l}
                </button>
              ))}
            </div>

            {[
              { label:"Valor del lote", value: tipo==="usd"?`USD ${fmt(monto)}`:`$ ${fmt(monto*TC)}`, min:20000, max:60000, step:500, val:monto, set:setMonto, lo:"USD 20.000", hi:"USD 60.000" },
              { label:"Anticipo", value:`${anticipo}%`, min:15, max:50, step:5, val:anticipo, set:setAnticipo, lo:"15%", hi:"50%" },
              { label:"Plazo", value:`${plazo} meses`, min:12, max:72, step:12, val:plazo, set:setPlazo, lo:"12 m.", hi:"72 m." },
            ].map(s => (
              <div key={s.label}>
                <div className="flex justify-between items-center mb-3">
                  <label className="text-xs uppercase tracking-widest text-slate-400 font-black">{s.label}</label>
                  <span className="text-sm font-black text-[#0055a5] bg-blue-50 px-3 py-1 rounded-full">{s.value}</span>
                </div>
                <input type="range" min={s.min} max={s.max} step={s.step} value={s.val}
                  onChange={e => s.set(+e.target.value)} className="w-full accent-[#0055a5] h-2"/>
                <div className="flex justify-between mt-2">
                  <span className="text-[10px] text-slate-300 font-bold">{s.lo}</span>
                  <span className="text-[10px] text-slate-300 font-bold">{s.hi}</span>
                </div>
              </div>
            ))}
          </div>

          {/* Panel resultado */}
          <div className="flex flex-col gap-4">
            <div className="bg-[#F9F7F2] rounded-3xl p-6 flex-1 space-y-4">
              {[
                { label:"Anticipo a pagar", val: tipo==="usd"?`USD ${fmt(anticipoImporte)}`:`$ ${fmt(anticipoImporte)}` },
                { label:"Monto a financiar", val: tipo==="usd"?`USD ${fmt(prestamo)}`:`$ ${fmt(prestamo)}` },
                { label:"Tasa mensual", val: tipo==="usd"?"0.5% (TNA 6%)":"3% (UVA referencial)" },
              ].map(r => (
                <div key={r.label} className="flex justify-between items-center py-3 border-b border-stone-200 last:border-0">
                  <p className="text-sm text-slate-500 font-medium">{r.label}</p>
                  <p className="text-sm font-black text-slate-800">{r.val}</p>
                </div>
              ))}
            </div>

            {/* Cuota destacada */}
            <div className="rounded-3xl p-8 text-white text-center" style={{background:"linear-gradient(135deg,#003d7a,#0055a5)"}}>
              <p className="text-xs uppercase tracking-[0.3em] opacity-60 font-bold mb-3">Cuota mensual estimada</p>
              <p className="text-5xl font-black mb-1">
                {tipo==="usd" ? `USD ${fmt(cuota)}` : `$ ${fmt(cuota)}`}
              </p>
              <p className="text-white/50 text-xs mt-2">{plazo} cuotas · sin sellados</p>
            </div>

            <button onClick={() => {
              const msg = `Hola, me gustaría consultar por una financiación personalizada con los siguientes datos:\n\n• Valor del lote: ${tipo==="usd" ? `USD ${fmt(monto)}` : `$ ${fmt(monto*TC)}`}\n• Anticipo (${anticipo}%): ${tipo==="usd" ? `USD ${fmt(anticipoImporte)}` : `$ ${fmt(anticipoImporte)}`}\n• Monto a financiar: ${tipo==="usd" ? `USD ${fmt(prestamo)}` : `$ ${fmt(prestamo)}`}\n• Plazo: ${plazo} meses\n• Cuota estimada: ${tipo==="usd" ? `USD ${fmt(cuota)}` : `$ ${fmt(cuota)}`}`;
              window.dispatchEvent(new CustomEvent('seleccionarLote', { detail: { mensaje: msg } }));
              document.getElementById("contacto")?.scrollIntoView({behavior:"smooth"});
            }}
              className="w-full bg-white border-2 border-[#0055a5] text-[#0055a5] py-4 rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-[#0055a5] hover:text-white active:scale-95 transition-all">
              Consultar financiación personalizada
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

// ─── FAQ ─────────────────────────────────────────────────────────────────────
function FAQ() {
  const [ref, visible] = useFadeIn();
  const [openIdx, setOpenIdx] = useState(null);
  const preguntas = [
    { q: "¿Los lotes cuentan con servicios?", a: "Sí. Todos los lotes disponen de acceso a energía eléctrica, agua potable, alumbrado público, calles enripiadas y cordón cuneta." },
    { q: "¿Puedo financiar la compra?", a: "Sí. Contamos con financiación propia tanto en pesos como en dólares." },
    { q: "¿Cuál es el anticipo mínimo?", a: "El anticipo mínimo es del 15% del valor del lote." },
    { q: "¿Cuál es el plazo máximo de financiación?", a: "Hasta 72 meses." },
    { q: "¿Se puede cancelar la financiación antes de tiempo?", a: "Sí, consultanos las condiciones de cancelación anticipada." },
    { q: "¿Cómo reservo un lote?", a: "Podés comunicarte con nosotros y te informaremos los pasos para realizar la reserva." },
    { q: "¿La financiación tiene requisitos bancarios?", a: "No. Al ser financiación propia, el proceso es más ágil y sencillo." },
  ];
  return (
    <section ref={ref} className="py-24 px-6 bg-[#F9F7F2]"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Preguntas frecuentes</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900">Lo que más nos preguntan</h2>
        </div>
        <div className="space-y-3">
          {preguntas.map((faq, i) => (
            <div key={i} className="bg-white rounded-2xl border border-stone-100 overflow-hidden shadow-sm">
              <button className="w-full px-6 py-5 flex justify-between items-center text-left gap-4"
                onClick={() => setOpenIdx(openIdx === i ? null : i)}>
                <span className="font-black text-slate-800 text-[15px] leading-snug">{faq.q}</span>
                <span className="flex-shrink-0 w-7 h-7 rounded-full bg-[#0055a5]/10 flex items-center justify-center transition-transform duration-300"
                  style={{ transform: openIdx === i ? "rotate(45deg)" : "none" }}>
                  <svg className="w-3 h-3 text-[#0055a5]" fill="none" viewBox="0 0 12 12">
                    <path d="M6 1v10M1 6h10" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                  </svg>
                </span>
              </button>
              <div style={{ maxHeight: openIdx === i ? 300 : 0, overflow:"hidden", transition:"max-height 0.3s ease" }}>
                <p className="px-6 pb-5 text-slate-500 leading-relaxed text-[15px]">{faq.a}</p>
              </div>
            </div>
          ))}
        </div>
        <div className="text-center mt-10">
          <p className="text-slate-500 text-sm mb-4">¿Tenés otra pregunta? Escribinos directamente.</p>
          <a href="#contacto"
            className="inline-flex items-center gap-2 bg-[#0055a5] text-white px-8 py-4 rounded-full font-black text-sm uppercase tracking-wider hover:bg-blue-700 transition-colors">
            Consultar ahora
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </a>
        </div>
      </div>
    </section>
  );
}

// ─── UBICACIÓN ────────────────────────────────────────────────────────────────
function Ubicacion() {
  const [ref, visible] = useFadeIn();
  return (
    <section ref={ref} id="ubicacion" className="py-24 px-6 bg-[#F9F7F2]"
      style={{ opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease" }}>
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-14">
          <span className="text-[11px] uppercase tracking-[0.35em] text-[#0055a5] font-black mb-3 block">Cómo llegar</span>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-3">Ubicación</h2>
          <p className="text-slate-500 max-w-xl mx-auto">Barrancas Blancas, Rawson, Chubut. A minutos de todo.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-8">
          {[
            { titulo:"5 min", sub:"de Playa Unión", icon: <svg className="w-9 h-9 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.3}><path strokeLinecap="round" strokeLinejoin="round" d="M3 9c.84-.68 1.8-1.02 2.75-1.02 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97M3 14c.84-.68 1.8-1.02 2.75-1.02 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97 1.56 0 2.94.78 3.75 1.97.81-1.19 2.19-1.97 3.75-1.97M12 3v2.25m6.364.386l-1.591 1.591M18.75 9a6.75 6.75 0 01-13.5 0"/></svg> },
            { titulo:"10 min", sub:"del centro de Rawson", icon: <svg className="w-9 h-9 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.3}><path strokeLinecap="round" strokeLinejoin="round" d="M3.75 21h16.5M4.5 3h15M5.25 3v18m13.5-18v18M9 6.75h1.5m-1.5 3h1.5m-1.5 3h1.5m3-6H15m-1.5 3H15m-1.5 3H15M9 21v-3.375c0-.621.504-1.125 1.125-1.125h3.75c.621 0 1.125.504 1.125 1.125V21"/></svg> },
            { titulo:"30 min", sub:"del aeropuerto de Trelew", icon: <svg className="w-9 h-9 text-[#0055a5]" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.3}><path strokeLinecap="round" strokeLinejoin="round" d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"/></svg> },
          ].map(d => (
            <div key={d.titulo} className="bg-white rounded-3xl p-8 text-center shadow-sm border border-stone-100">
              <div className="flex justify-center mb-4">{d.icon}</div>
              <p className="text-3xl font-black text-[#0055a5] mb-1">{d.titulo}</p>
              <p className="text-sm text-slate-500 font-medium">{d.sub}</p>
            </div>
          ))}
        </div>

        <div className="rounded-3xl overflow-hidden shadow-xl border border-stone-100" style={{height:420}}>
          <iframe title="Ubicación" width="100%" height="100%" style={{border:0}} loading="lazy" allowFullScreen
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3000.0!2d-65.052833!3d-43.357222!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDPCsDIxJzI2LjAiUyA2NcKwMDMnMTAuMiJX!5e0!3m2!1ses!2sar!4v1234567890"/>
        </div>
      </div>
    </section>
  );
}

// ─── CONTACTO ─────────────────────────────────────────────────────────────────
function Contacto() {
  const [ref, visible] = useFadeIn(0.05);
  const [form, setForm] = useState({ nombre:"", email:"", telefono:"", lote:"", mensaje:"" });
  const [sent, setSent] = useState(false);
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(false);
  const onChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  useEffect(() => {
    const handler = (e) => {
      const { manzana, lote, mensaje } = e.detail;
      setForm(f => ({
        ...f,
        ...(lote != null ? { lote: `Manzana ${manzana} - Lote ${lote}` } : {}),
        ...(mensaje ? { mensaje } : {}),
      }));
    };
    window.addEventListener('seleccionarLote', handler);
    return () => window.removeEventListener('seleccionarLote', handler);
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    setSending(true);
    setError(false);
    try {
      const res = await fetch("https://formspree.io/f/mreobqov", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ nombre: form.nombre, email: form.email, telefono: form.telefono, lote: form.lote, mensaje: form.mensaje }),
      });
      if (res.ok) { setSent(true); } else { setError(true); }
    } catch { setError(true); }
    finally { setSending(false); }
  };

  return (
    <section ref={ref} id="contacto" className="py-24 px-6 relative overflow-hidden"
      style={{background:"linear-gradient(135deg, #002855 0%, #0055a5 100%)", opacity: visible ? 1 : 0, transform: visible ? "none" : "translateY(40px)", transition: "opacity 0.8s ease, transform 0.8s ease"}}>
      {/* Decoración */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] rounded-full opacity-5" style={{background:"radial-gradient(circle,white,transparent)",transform:"translate(30%,-30%)"}}/>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] rounded-full opacity-5" style={{background:"radial-gradient(circle,white,transparent)",transform:"translate(-30%,30%)"}}/>

      <div className="max-w-4xl mx-auto relative z-10">
        <div className="text-center mb-14">
          <span className="text-white/50 text-[11px] uppercase tracking-[0.35em] font-black mb-4 block">Contacto</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mb-4">¿Hablamos de tu lote?</h2>
          <p className="text-white/60 text-lg max-w-lg mx-auto font-light leading-relaxed">
            Dejanos tus datos y un asesor te contacta con el plano actualizado y las opciones de financiación.
          </p>
        </div>

        {sent ? (
          <div className="bg-white/10 backdrop-blur rounded-3xl p-16 text-center border border-white/20">
            <div className="w-16 h-16 rounded-full bg-green-400/20 flex items-center justify-center mx-auto mb-6">
              <svg className="w-8 h-8 text-green-400" fill="none" viewBox="0 0 24 24">
                <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
            <h3 className="text-white text-2xl font-black mb-2">¡Consulta enviada!</h3>
            <p className="text-white/60">Te contactamos a la brevedad. Gracias por tu interés.</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit}
            className="bg-white/10 backdrop-blur rounded-3xl p-8 border border-white/15 grid md:grid-cols-2 gap-4">
            {[
              { name:"nombre", label:"Nombre completo", type:"text", required:true, col:1 },
              { name:"email",  label:"Email",           type:"email",required:true, col:1 },
              { name:"telefono",label:"Teléfono",       type:"tel",  required:false,col:1 },
              { name:"lote",   label:"Lote de interés", type:"text", required:false,col:1 },
            ].map(f => (
              <div key={f.name}>
                <label className="block text-white/60 text-xs uppercase tracking-widest font-bold mb-2">{f.label}{f.required&&<span className="text-blue-300 ml-1">*</span>}</label>
                <input name={f.name} type={f.type} value={form[f.name]} onChange={onChange} required={f.required}
                  className="w-full bg-white/10 border border-white/20 rounded-2xl px-4 py-3.5 text-white placeholder-white/30 focus:outline-none focus:bg-white/20 focus:border-white/40 transition-all"
                  placeholder={f.label}/>
              </div>
            ))}
            <div className="md:col-span-2">
              <label className="block text-white/60 text-xs uppercase tracking-widest font-bold mb-2">Mensaje</label>
              <textarea name="mensaje" value={form.mensaje} onChange={onChange} rows={4} placeholder="Contanos en qué podemos ayudarte..."
                className="w-full bg-white/10 border border-white/20 rounded-2xl px-4 py-3.5 text-white placeholder-white/30 focus:outline-none focus:bg-white/20 focus:border-white/40 transition-all resize-none"/>
            </div>
            <div className="md:col-span-2">
              <button type="submit"
                className="w-full bg-white text-[#0055a5] py-5 rounded-2xl font-black uppercase tracking-widest text-sm hover:bg-blue-50 active:scale-[0.98] transition-all shadow-2xl disabled:opacity-60"
              disabled={sending}>
              {sending ? "Enviando..." : "Enviar consulta"}
            </button>
            {error && <p className="text-red-300 text-sm text-center mt-3">Hubo un error. Intentá de nuevo o escribinos por WhatsApp.</p>}
            </div>
          </form>
        )}
      </div>
    </section>
  );
}

// ─── FOOTER ───────────────────────────────────────────────────────────────────
function Footer() {
  return (
    <footer className="bg-slate-900 text-white px-6 pt-16 pb-8">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-3 gap-12 pb-12 border-b border-white/10">
          {/* Logo + descripción */}
          <div>
            <img
              src="https://res.cloudinary.com/dtvtmh8hq/image/upload/f_auto,q_auto/v1773871049/ChatGPT_Image_16_dic_2025_03_55_53_z1g4sb.png"
              alt="Garzonio" className="h-16 w-auto object-contain mb-4"
              style={{filter:"brightness(0) invert(1)"}} onError={e=>e.target.style.display="none"}/>
            <p className="text-slate-400 text-sm leading-relaxed">
              Casi 50 años eligiendo los mejores terrenos de la Patagonia. Barrancas Blancas es nuestra propuesta más exclusiva frente al Atlántico.
            </p>
          </div>
          {/* Links */}
          <div>
            <p className="text-xs uppercase tracking-widest font-black text-slate-500 mb-5">Navegación</p>
            <ul className="space-y-3">
              {[["#proyecto","El Proyecto"],["#empresa","Nosotros"],["#lotes","Masterplan de Lotes"],["#financiamiento","Financiamiento"],["#ubicacion","Ubicación"],["#contacto","Contacto"]].map(([h,l])=>(
                <li key={h}>
                  <a href={h} className="text-slate-400 hover:text-white transition-colors text-sm font-medium">{l}</a>
                </li>
              ))}
            </ul>
          </div>
          {/* Contacto */}
          <div>
            <p className="text-xs uppercase tracking-widest font-black text-slate-500 mb-5">Contacto directo</p>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0">
                  <svg className="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24"><path d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <span className="text-slate-400 text-sm">Inmigrantes 224, Trelew, Chubut</span>
              </li>
              <li>
                <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 group">
                  <div className="w-8 h-8 rounded-full bg-[#25D366]/20 flex items-center justify-center flex-shrink-0 group-hover:bg-[#25D366]/40 transition-colors">
                    <svg className="w-4 h-4 text-[#25D366]" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                    </svg>
                  </div>
                  <span className="text-slate-400 text-sm group-hover:text-white transition-colors">WhatsApp directo</span>
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="flex items-center gap-3 group">
                  <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-white/20 transition-colors">
                    <svg className="w-4 h-4 text-slate-400" fill="none" viewBox="0 0 24 24">
                      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <span className="text-slate-400 text-sm group-hover:text-white transition-colors">{EMAIL}</span>
                </a>
              </li>
              <li>
                <a href="https://www.instagram.com/garzonioprop/" target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 group">
                  <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-pink-500/30 transition-colors">
                    <svg className="w-4 h-4 text-slate-400 group-hover:text-pink-400 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/>
                    </svg>
                  </div>
                  <span className="text-slate-400 text-sm group-hover:text-white transition-colors">@garzonioprop</span>
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/garzoniopropiedades" target="_blank" rel="noopener noreferrer"
                  className="flex items-center gap-3 group">
                  <div className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-500/30 transition-colors">
                    <svg className="w-4 h-4 text-slate-400 group-hover:text-blue-400 transition-colors" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                    </svg>
                  </div>
                  <span className="text-slate-400 text-sm group-hover:text-white transition-colors">Garzonio Propiedades</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-600 text-xs">© 2026 Garzonio Propiedades — Todos los derechos reservados.</p>
          <p className="text-slate-600 text-xs">Trelew, Chubut, Argentina</p>
        </div>
      </div>
    </footer>
  );
}

// ─── WHATSAPP FLOTANTE ────────────────────────────────────────────────────────
function WhatsApp() {
  const [vis, setVis] = useState(false);
  useEffect(() => {
    const fn = () => setVis(window.scrollY > 500);
    window.addEventListener("scroll", fn, { passive:true });
    return () => window.removeEventListener("scroll", fn);
  }, []);
  return (
    <a href={`https://wa.me/${WHATSAPP}?text=Hola! Quiero consultar sobre los lotes de Barrancas Blancas.`}
      target="_blank" rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-3 bg-[#25D366] text-white font-black py-3.5 px-5 rounded-full shadow-2xl hover:scale-105 active:scale-95 transition-all"
      style={{ opacity:vis?1:0, pointerEvents:vis?"auto":"none", transition:"opacity 0.4s, transform 0.2s",
        boxShadow:"0 8px 32px rgba(37,211,102,0.4)" }}>
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
      </svg>
      <span className="text-sm hidden sm:block">Consultá por WhatsApp</span>
    </a>
  );
}

// ─── APP ──────────────────────────────────────────────────────────────────────
export default function App() {
  return (
    <div className="font-sans text-slate-900">
      <Navbar />
      <Hero />
      <StatsBar />
      <Proyecto />
      <Galeria />
      <Empresa />
      <LotesDestacados />
      <SeccionLotes />
      <Financiamiento />
      <FAQ />
      <Ubicacion />
      <Contacto />
      <Footer />
      <WhatsApp />
    </div>
  );
}
